import type { Entities, ColumnStackValues } from './types';

export const mapSumPositiveValues = (
  keys: string[],
  entities: Entities
): number[] => {
  return keys
    .map((key) => {
      const columnValues = entities[key];
      if (!columnValues) {
        return null;
      }
      return columnValues
        .filter((val) => val && val >= 0)
        .reduce((acc: number, value) => acc + (value ?? 0), 0);
    })
    .filter((n): n is number => n !== null);
};

export const mapSumNegativeValues = (
  keys: string[],
  entities: Entities
): number[] => {
  return keys
    .map((key) => {
      const columnValues = entities[key];
      if (!columnValues) {
        return null;
      }
      return columnValues
        .filter((val) => val && val < 0)
        .reduce((acc: number, value) => acc + (value ?? 0), 0);
    })
    .filter((n): n is number => n !== null);
};

type CalcColumnYValuesParams = {
  columnValues: ColumnStackValues;
  columnHeightValues: number[];
};

export const calcColumnYValues = ({
  columnValues,
  columnHeightValues,
}: CalcColumnYValuesParams) => {
  return columnValues.map((value, i) => {
    const isNotPositive = !value || value <= 0;
    if (isNotPositive) {
      return columnHeightValues
        .slice(0, i)
        .filter((n) => n >= 0)
        .reduce((acc, value) => acc + value, 0);
    }

    return columnHeightValues
      .slice(0, i + 1)
      .filter((n) => n < 0)
      .reduce((acc, value) => acc + value, 0);
  });
};
